module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[84]205.a887aec.woff2";